import React from 'react';
import NavBar from '../components/NavBar';
import './RehberlikPage.css';
import rehberlikImg from '../assets/q1.jpeg'; // kendi görselinizi koyun

export default function RehberlikPage() {
  return (
    <>
      <NavBar />

      <section id="rehberlik-page" className="rehberlik-page">
        {/* Hero */}
        <div className="hero">
          <img src={rehberlikImg} alt="Rehberlik Hizmetleri" className="hero-img" />
          <div className="overlay" />
          <h1 className="hero-title">Rehberlik</h1>
        </div>

        {/* İçerik */}
        <div className="content">
          <h2>Rehberlik ve Psikolojik Danışma Birimi</h2>
          <p>
          Rehberlik ve Psikolojik Danışma Birimimiz, öğrencilerimizin gelişimlerini desteklemek amacıyla hizmet vermektedir. Her öğrencinin bireysel farklılıkları göz önünde bulundurularak; akademik, kişisel, kariyer, sosyal ve duygusal alanlarda kendini tanıyan, empati kurabilen, sorumluluk sahibi ve çevresiyle sağlıklı iletişim kurabilen bireyler olarak yetişmeleri hedeflenmektedir.

        Birimimiz, öğrenci merkezli bir anlayışla, yapılan gözlem, takip ve iş birliği doğrultusunda her bireyin potansiyelini ortaya koymasına yardımcı olmayı amaçlamaktadır.

        Anaokulu, ilkokul ve ortaokul kademelerinde, öğrencilerimizin gelişimsel dönemleri dikkate alınarak hazırlanan sistemli takip programları doğrultusunda çalışmalar yürütülmektedir.

        Yapılan bireysel öğrenci ve veli görüşmeleri; gizlilik, saygınlık, güvenirlik ve çözüm odaklılık ilkeleri çerçevesinde gerçekleştirilmektedir.
          </p>

          
        </div>
      </section>
    </>
  );
}
